import {Component, ElementRef, OnInit} from '@angular/core';
import {routerTransition} from "./core/animations/router-transition.animation";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routerTransition]
})
export class AppComponent implements OnInit {
  title = 'CIR';
  public skipToMainContentLink: string;
  private _skipLinkTarget: string = '#router-outlet-container';

  constructor(private appElement: ElementRef, private router: Router){}

  ngOnInit() {
    this.initRouterSub();
    this.skipToMainContentLink = `${this.router.url}${this._skipLinkTarget}`;
  }

  getPage(outlet) {
    return outlet.activatedRouteData['page'] || 'home';
  }

  public focusToMainContent(): void {
    const element = this.appElement.nativeElement.querySelector(`${this._skipLinkTarget}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth"} );
      element.focus();
    }
  }

  private initRouterSub(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        window.scrollTo(0, 0);

        if (!event.url.includes(`${this._skipLinkTarget}`)) {
          this.skipToMainContentLink = `${event.url}${this._skipLinkTarget}`;
        }
      });
  }

}
